import _ from 'lodash';
import { apiSearch, apiFetch } from '../utility';

const apiBase = 'bulkDelivery';
const word = 'bulk delivery';
const onSuccessRedirectTo = `/logistics/bulkDeliveries`;

export const search = (p = {}) => {
	const {callback = _.noop} = p;
	return dispatch => {
		apiSearch({
			base : apiBase,
			dispatch,
			callback,
		});
	};
};

export const get = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

export const publicGet = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.public.get`,
			params,
			dispatch,
			callback,
		});
	};
};

export const submitLoadingNumbers = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.public.submitLoadingNumbers`,
			params,
			dispatch,
			callback,
		});
	};
};

export const carrierConfirm = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.public.carrierConfirm`,
			params,
			dispatch,
			callback,
		});
	};
};

export const supplierConfirm = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.public.supplierConfirm`,
			params,
			dispatch,
			callback,
		});
	};
};


export const add = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.add`,
			listNameToUpdate : 'bulkDeliveryIds',
			params,
			dispatch,
			callback,
		});
	};
};

export const getNextEmail = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: 'bulkDelivery.getNextEmail',
			params,
			dispatch,
			callback,
		});
	};
};

export const activate = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: 'bulkDelivery.activate',
			params,
			dispatch,
			successMessage : `Bulk Delivery scheduled successfully. ` +
				`Click to continue to return to ${word} page.`,
			onSuccessRedirectTo,
			callback
		});
	};
};

export const update = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.update`,
			params,
			dispatch,
			successMessage : `The ${word} updated successfully. 
				Click continue to return to the ${word} page.)`,
			onSuccessRedirectTo,
			callback,
		});
	};
};

export const getPotentialChanges = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.potential.update`,
			params,
			dispatch,
			callback,
		});
	};
};

export const searchLogs = ({bulkDeliveryId, callback = _.noop}) => {
	return dispatch => {
		apiSearch({
			method : 'bulkDelivery.log.search',
			base : 'bulkDeliveryLog',
			keyBy : bulkDeliveryId,
			params : {
				bulkDeliveryId,
			},
			dispatch,
			callback,
		});
	};
};

export const cancel = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.cancel`,
			params,
			dispatch,
			successMessage : `Bulk Delivery cancelled successfully. Cancellation emails have been sent.`,
			onSuccessRedirectTo,
			callback
		});
	};
};